import { render, staticRenderFns } from "./monthPriceDialog.vue?vue&type=template&id=496ce5bf&scoped=true"
import script from "./monthPriceDialog.vue?vue&type=script&lang=js"
export * from "./monthPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./monthPriceDialog.vue?vue&type=style&index=0&id=496ce5bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ce5bf",
  null
  
)

export default component.exports